// Shared visual lifecycle only; scrolling and pagination remain with each component.
export default {
  mounted() {
    const el = this.$el.querySelector('.ai-list-scroll')
    if (!el) return
    let timer
    const hide = () => el.classList.remove('scrollbar-visible')
    const reveal = () => {
      clearTimeout(timer)
      if (el.scrollHeight <= el.clientHeight + 1) { hide(); return }
      el.classList.add('scrollbar-visible')
      timer = setTimeout(hide, 900)
    }
    const events = ['scroll', 'pointerenter', 'pointerdown', 'keydown']
    events.forEach(name => el.addEventListener(name, reveal, { passive: true }))
    this._disposeScrollbar = () => {
      clearTimeout(timer)
      events.forEach(name => el.removeEventListener(name, reveal))
      hide()
    }
  },
  beforeDestroy() { if (this._disposeScrollbar) this._disposeScrollbar() }
}
